import React, { PureComponent } from "react";
import { PortionsContext } from "../context/PortionsContext";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";

class InputSearch extends PureComponent {
  constructor(props) {
    super(props);
    this._debouncedSearch = debounce(this._search, 500);
  }

  _search = (value) => {
    this.context.search(value);
  };

  handleChange = (e) => {
    this._debouncedSearch(e.target.value);
  };

  render() {
    const { className, mode, showText } = this.props;
    return (
      <>
        {
          mode !== 'button' &&
          <div className="">
            <input
              onChange={this.handleChange}
              className={`${className} shadow1`}
              type="text"
              placeholder="BUSCAR"
            />
            {
              showText &&
              <p className="home-input-description">Escribe el nombre de la ciudad o la fracción</p>
            }
          </div>
        }

        {
          mode == 'button' &&
          <div>
            <input
              className={`home-input home-mapInput desktop-noDisplay shadow1`}
              type="text"
              placeholder="BUSCAR"
              onChange={this.handleChange}
            ></input>
            <button
              className="home-filtersButton desktop-noDisplay shadow1"
              onClick={this.context.togglePortionsList}
            >
              <span>Listado</span>
            </button>
          </div>
        }
      </>
    );
  }
}

InputSearch.contextType = PortionsContext;
InputSearch.defaultProps = {
  className: "home-input",
  mode: 'button',
  showText: true,
}

InputSearch.propTypes = {
  className: PropTypes.string,
  showButton: PropTypes.string,
  showText: PropTypes.bool,
}

export default InputSearch;
